import "../stylesheets/style_front_top";
require("modules/front/top/common.js");
